import { gql } from "@apollo/client";

export const SHARED_PACKS_QUERY = gql`
  query($scenarioId: ID!, $originId: ID!, $input: SharedPackComponentsInput!) {
    data(scenarioId: $scenarioId, originId: $originId) {
      sharedPackComponents(input: $input) {
        numericGroupCode
        groupCodeSeparator
        component
        order
        prefix
        code
        existingLabels
      }
    }
  }
`;
